import { HttpContextToken } from '@angular/common/http';

// Requests can provide a translated, user-facing message instead of backend details.
export const HTTP_ERROR_MESSAGE = new HttpContextToken<string | null>(() => null);
